(function brandSystem() {
  const root = document.documentElement;
  const storageKey = 'cc-theme-mode';
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  const isSupportedMode = (value) => ['light', 'dark'].includes(value);

  const getStoredMode = () => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (isSupportedMode(stored)) {
        return stored;
      }

      if (stored) {
        window.localStorage.removeItem(storageKey);
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  const getResolvedScheme = (mode) => (mode ? mode : (mediaQuery.matches ? 'dark' : 'light'));

  const syncModeToggle = (scheme) => {
    const toggle = document.querySelector('[data-theme-toggle]');

    if (!toggle) {
      return;
    }

    const nextScheme = scheme === 'dark' ? 'light' : 'dark';
    const nextLabel = nextScheme === 'dark' ? 'dark' : 'light';

    toggle.dataset.themeScheme = scheme;
    toggle.dataset.nextThemeMode = nextScheme;
    toggle.setAttribute('aria-pressed', scheme === 'dark' ? 'true' : 'false');
    toggle.setAttribute('aria-label', `Switch to ${nextLabel} mode`);
    toggle.setAttribute('title', `Switch to ${nextLabel} mode`);
  };

  const applyMode = (mode) => {
    const nextMode = isSupportedMode(mode) ? mode : null;
    const resolvedScheme = getResolvedScheme(nextMode);

    root.dataset.themeMode = nextMode || 'system';
    root.dataset.themeScheme = resolvedScheme;
    syncModeToggle(resolvedScheme);
  };

  const persistMode = (mode) => {
    try {
      if (isSupportedMode(mode)) {
        window.localStorage.setItem(storageKey, mode);
      } else {
        window.localStorage.removeItem(storageKey);
      }
    } catch (error) {
      /* no-op */
    }
  };

  const preserveScrollPosition = (callback) => {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    callback();

    const restoreScroll = (remainingFrames = 2) => {
      window.scrollTo(scrollX, scrollY);

      if (remainingFrames > 0) {
        window.requestAnimationFrame(() => restoreScroll(remainingFrames - 1));
      }
    };

    window.requestAnimationFrame(() => restoreScroll());
  };

  document.addEventListener('click', (event) => {
    const modeToggle = event.target.closest('[data-theme-toggle]');

    if (modeToggle) {
      const nextMode = root.dataset.themeScheme === 'dark' ? 'light' : 'dark';
      preserveScrollPosition(() => {
        persistMode(nextMode);
        applyMode(nextMode);
      });
      event.preventDefault();
      return;
    }
  });

  const onSchemeChange = () => {
    if (!getStoredMode()) {
      applyMode(null);
    }
  };

  try {
    mediaQuery.addEventListener('change', onSchemeChange);
  } catch (error) {
    mediaQuery.addListener(onSchemeChange);
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyMode(getStoredMode());
  });
})();
